import React from 'react';
import { UptimeGrid, UptimeBox, UptimeLoader } from '@uptime/uptime-component';
import { useTranslation } from 'react-i18next';
/**
 * Props for the LoadingScreen icon
 **/
interface LoadingScreenProps {
  loaderSize?: 'sm' | 'lg' | 'md';
  caption?: string;
  className?: string;
}

/**
 * Generic loading screen. Displays a loading animation.
 */
const LoadingScreen: React.FC<LoadingScreenProps> = ({
  loaderSize,
  caption,
  ...props
}) => {
const { t } = useTranslation('common');
return (
  <UptimeGrid
    height="100%"
    alignItems="center"
    justifyContent="center"
    data-testid="loading"
    {...props}
  >
    <UptimeBox>
      <UptimeLoader size={loaderSize || 'md'} caption={caption || t("common:loading")}/>
    </UptimeBox>
  </UptimeGrid>
)};

export default LoadingScreen;
